export default  [
  {
    key: "owner",
    label: "Owner",
    sortable: true
  },

  {
    key: "contract",
    label: "Contract",
    sortable: true
  },
  {
    key: "plan",
    label: "Plan",
    sortable: true
  },

  {
    key: "device",
    label: "Device",
    sortable: true
  },

  // {
  //   key: "plate",
  //   label: "Plate Number",
  //   sortable: true
  // },


  {
    key: "date",
    label: "Date",
    sortable: true
  },


  {
    key: "day",
    label: "Day",
    sortable: true
  },

  {
    key: "start",
    label: "start",
    sortable: true
  },

  {
    key: "end",
    label: "end",
    sortable: true
  },


  {
    key: "to_achieve",
    label: "To achieve",
    sortable: true
  },

  {
    key: "achieved_outPlan",
    label: "out plan",
    sortable: true
  },

  {
    key: "achieved_outGeofence",
    label: "out work area",
    sortable: true
  },

  {
    key: "achieved",
    label: "achieved",
    sortable: true
  },

  {
    key: "total_achieved",
    label: "total achieved",
    sortable: true
  },

  {
    key: "percent",
    label: "percent",
    sortable: true
  },

  {
    key: 'action',
    label: 'Action'
  }

]